@if (progressInfo; as progress) {
	<div class="cell" [ngClass]="'bg-' + status">
		<div class="progress-bar" [style.width.%]="progress.percent" [ngClass]="'status-' + status"></div>
		<span class="label">
			{{ status !== 'irrelevant' ? ('mes.production-plan.status.' + status | translate) + ' ' + progress.text : '' }}
		</span>
	</div>
}
